import { jsx as t } from "react/jsx-runtime";
import { m as f } from "../chunks/make-refs.cb0b9b76.js";
import { forwardRef as l } from "react";
import { t as i } from "../chunks/common.c5b78887.js";
const g = l(
  ({ className: r, label: e, variant: m = "default", ...o }, a) => {
    const { $el: s } = f(a, ["$el"]);
    return /* @__PURE__ */ t("mark", { ref: s, className: i({ className: r, variant: m }), ...o, children: e });
  }
);
export {
  g as Tag
};
//# sourceMappingURL=Tag.js.map
